const languages = [
  { value: 'SQ', label: 'Albanian [SQ]' },
  { value: 'DE', label: 'Allemand [DE]' },
  { value: 'GB', label: 'English (UK) [GB]' },
  { value: 'EN', label: 'English (USA) [EN]' },
  { value: 'AR', label: 'Arab [AR]' },
  { value: 'HY', label: 'Armenian [HY]' },
  { value: 'AZ', label: 'Azerbaijani [AZ]' },
  { value: 'BZ', label: 'Brezhoneg (Breton) [BZ]' },
  { value: 'BG', label: 'Bulgarian [BG]' },
  { value: 'CA', label: 'Catalan [CA]' },
  { value: 'ZH', label: 'Simplified Chinese [ZH]' },
  { value: 'TW', label: 'Traditional Chinese [TW]' },
  { value: 'KO', label: 'Korean [KO]' },
  { value: 'HR', label: 'Croatian [HR]' },
  { value: 'DA', label: 'Danish [DA]' },
  { value: 'ES', label: 'Spanish [ES]' },
  { value: 'AG', label: 'Spanish-Argentine [AG]' },
  { value: 'MX', label: 'Spanish-Mexican [MX]' },
  { value: 'ET', label: 'Estonian [ET]' },
  { value: 'EU', label: 'Euskera (Basque) [EU]' },
  { value: 'FI', label: 'Finnish [FI]' },
  { value: 'FR', label: 'French [FR]' },
  { value: 'QC', label: 'French CA [QC]' },
  { value: 'GL', label: 'Gallego [GL]' },
  { value: 'EL', label: 'Greek [EL]' },
  { value: 'KA', label: 'Georgian [KA]' },
  { value: 'NL', label: 'Dutch [NL]' },
  { value: 'HU', label: 'Hungarian [HU]' },
  { value: 'HE', label: 'Hebrews [HE]' },
  { value: 'ID', label: 'Indonesian [ID]' },
  { value: 'IT', label: 'Italian [IT]' },
  { value: 'JA', label: 'Japanese [JA]' },
  { value: 'LO', label: 'Lao [LO]' },
  { value: 'LV', label: 'Latvian [LV]' },
  { value: 'LT', label: 'Lithuanian [LT]' },
  { value: 'MS', label: 'Malaysian [MS]' },
  { value: 'NO', label: 'Norwegian [NO]' },
  { value: 'NN', label: 'Nynorsk (Norwegian) [NN]' },
  { value: 'FA', label: 'Persian [FA]' },
  { value: 'PL', label: 'Polish [PL]' },
  { value: 'PT', label: 'Portuguese [PT]' },
  { value: 'BR', label: 'Portuguese-Brazilian [BR]' },
  { value: 'RO', label: 'Romanian [RO]' },
  { value: 'RU', label: 'Russian [RU]' },
  { value: 'SR', label: 'Serbian [SR]' },
  { value: 'SK', label: 'Slovak [SK]' },
  { value: 'SI', label: 'Slovenian [SI]' },
  { value: 'SV', label: 'Swedish [SV]' },
  { value: 'CS', label: 'Czech [CS]' },
  { value: 'TH', label: 'Thai [TH]' },
  { value: 'TR', label: 'Turkish [TR]' },
  { value: 'UK', label: 'Ukrainian [UK]' },
  { value: 'VN', label: 'Vietnamese [VN]' },
  { value: 'MK', label: 'македонски (Macedonian) [MK]' },
  { value: 'UG', label: 'ئۇيغۇر (Uyghur) [UG]' },
  { value: 'UR', label: 'اردو (Urdu) [UR]' },
  { value: 'SH', label: 'سنڌي (Sinhala) [SH]' },
  { value: 'BN', label: 'বাংলা (Bengali) [BN]' },
];

export { languages as default };



// WEBPACK FOOTER //
// ./src/utils/languages.js